import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	statusColorRed: {
		...ColorUtil.getBackgroundAndContrastColor(colors.red[100])
	},
	statusColorGreen: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[200])
	},
	statusColorGray: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
	},
	statusColorYellow: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[100])
	},
	webhookBodyIcon: {
		color: colors.gray[900]
	},
	chatIcon: {
		color: themeColors.getPrimaryColor()
	}
})

export default useStyles
